import _ from 'lodash'

import {
  ADD_SHOWCASE_FIELD_ERROR,
  ADD_SHOWCASE_FIELDS_ERRORS,
  CHANGE_SHOWCASE_FORM_FIELD,
  CLEAR_SHOWCASE_FIELD_ERROR,
  PREDEFINE_SHOWCASE_FORM_DATA,
  RESET_SHOWCASE_FORM_DATA,
} from './actions'

const defaultFormData = (predefined: Record<string, unknown> = {}) =>
  _.merge(
    {
      id: null as string | null,
      slug: null as string | null,
      body: '',
      author: '',
      authorPhotoUrl: null as string | null,
      fileUrl: '',
      fileType: '',
      isStatic: false,
    },
    _.pickBy(predefined, _.identity),
  )

interface FormState {
  data: ReturnType<typeof defaultFormData>
  errors: Record<string, string | undefined>
}

const initialState = (): FormState => ({
  data: defaultFormData(),
  errors: {},
})

type Action =
  | { type: typeof CHANGE_SHOWCASE_FORM_FIELD; payload: { key: string; value: unknown } }
  | { type: typeof ADD_SHOWCASE_FIELD_ERROR; payload: { field: string; error: string } }
  | { type: typeof ADD_SHOWCASE_FIELDS_ERRORS; payload: { errors: Record<string, unknown> } }
  | { type: typeof CLEAR_SHOWCASE_FIELD_ERROR; payload: { field: string } }
  | { type: typeof RESET_SHOWCASE_FORM_DATA }
  | { type: typeof PREDEFINE_SHOWCASE_FORM_DATA; payload: Record<string, unknown> }

export default function reducer(state: FormState = initialState(), action: Action): FormState {
  switch (action.type) {
    case CHANGE_SHOWCASE_FORM_FIELD:
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.key]: action.payload.value,
        },
      }

    case ADD_SHOWCASE_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: action.payload.error,
        },
      }

    case ADD_SHOWCASE_FIELDS_ERRORS:
      return {
        ...state,
        errors: action.payload.errors as Record<string, string | undefined>,
      }

    case CLEAR_SHOWCASE_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: undefined,
        },
      }

    case RESET_SHOWCASE_FORM_DATA:
      return {
        ...state,
        data: defaultFormData(),
        errors: {},
      }

    case PREDEFINE_SHOWCASE_FORM_DATA:
      return {
        ...state,
        data: defaultFormData(action.payload),
        errors: {},
      }

    default:
      return state
  }
}
